export const REMOVE_INTERNAL_MARKETER_PRODUCT_ACCESS = 'REMOVE_INTERNAL_MARKETER_PRODUCT_ACCESS';
export type REMOVE_INTERNAL_MARKETER_PRODUCT_ACCESS = typeof REMOVE_INTERNAL_MARKETER_PRODUCT_ACCESS;

export interface RemoveInternalMarketerProductAccess {
    type: REMOVE_INTERNAL_MARKETER_PRODUCT_ACCESS;
    productId: string;
}

export function removeInternalMarketerProductAccessAction(productId: string): RemoveInternalMarketerProductAccess {
    return {
        type: REMOVE_INTERNAL_MARKETER_PRODUCT_ACCESS,
        productId
    };
}
